import { Divider, IconButton, InputBase, Paper, Typography } from "@material-ui/core";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { withRouter } from "react-router-dom";
import ColorButton from "~/components/common/colorButton/ColorButton";
import FeaturesSelected from "~/components/common/featuresSelected/FeaturesSelected";
import businessService from "~/services/businessService";
import { SearchIcon } from "~/components/common/icons/Icons";
import SpinnerLoading from "~/components/common/spinnerLoading/SpinnerLoading";
import useStyles from "./styles";
import { useTranslation } from "react-i18next";
import PurpleCheckBox from "~/components/common/purpleCheckBox/purpleChackBox";
import { ArrowBackIos, KeyboardArrowDown, KeyboardArrowRight } from "@material-ui/icons";
import servicesService from "~/services/servicesService";
import TitleContainer from "~/components/common/titleContainer/TitleContainer";
import { useContext } from "react";
import { DialogBuilder } from "~/utils/DialogProvider";
import couponServices from "~/services/couponServices";
import { useLocation, useParams } from "react-router-dom/cjs/react-router-dom.min";
import businessAction from "~/store/actions/businessAction";
import CustomCardHeader from "~/components/common/customCardHeader/CustomCardHeader";
import Utils from "~/helpers/Utils";
import { handleBreadcrumb, handleError } from "~/utils/handleError";

import { packagesList } from "~/services/packagesServices";
import { buildPackageLabel } from "~/utils/packages";

const ServiceScheduling = (props) => {
	const dialog = useContext(DialogBuilder);
	const classes = useStyles();
	const selectedCategorie = props?.location?.state?.categorie;
	const pet = props?.location?.state?.pet;
	const coupon = props?.location?.state?.coupon;

	const { business } = useSelector((store) => store.business);
	const { t } = useTranslation();
	const { user } = useSelector((store) => store.auth);

	const [selectedServices, setSelectedServices] = useState([]);
	const [services, setServices] = useState([]);
	const [servicesTree, setServicesTree] = useState([]);
	const [openedBranchs, setOpenedBranchs] = useState([]);
	const [search, setSearch] = useState("");
	const [loading, setLoading] = useState(false);
	const [treeView] = useState(false);
	const [currentLevel, setCurrentLevel] = useState([]);
	const [packageLabelMap, setPackageLabelMap] = useState({});
	const { id } = useParams();
	const dispatch = useDispatch();
	const location = useLocation();
	const queryParams = new URLSearchParams(location.search);
	const serviceId = queryParams.get('serviceId');
	const categoryId = queryParams.get('categoryId');

	let categoryIdValue = categoryId ? categoryId : selectedCategorie?.id || business.categories[0].id;

	useEffect(() => {
		setLoading(true);
		if (business?.id) {
			if (coupon) {
				couponServices
					.getBusinessServiceCoupons(
						business.id,
						selectedCategorie?.id || business.categories[0].id,
						coupon.coupon.coupon_id,
						pet?.featureNames[0],
						pet?.featureNames[1]
					)
					.then((res) => {
						let businessServices = res.data;
						if (businessServices) {
							setServices(businessServices);
							let tree = servicesService.buildServiceTree(businessServices, business.language);
							if (pet) {
								tree = servicesService.petPreselection(tree, pet);
							}
							setServicesTree(tree);
							setCurrentLevel(tree);
						}
						setLoading(false);
					})
					.catch((err) => {
						handleError(err, 'ServiceScheduling/getBusinessServiceCoupons');
						dialog
							.withTitle(t("Unable to load the services"))
							.withMessage(err.message)
							.withAction(() => props.history.goBack())
							.show();
						setLoading(false);
					});
			} else {
				businessService
					.getBusinessService(
						business.id,
						categoryIdValue,
						business.language,
						pet?.featureNames[0],
						pet?.featureNames[1]
					)
					.then((res) => {
						let businessServices = res.data;
						if (businessServices) {
							setServices(businessServices);
							let tree = servicesService.buildServiceTree(businessServices, business.language);
							if (pet) {
								tree = servicesService.petPreselection(tree, pet);
							}
							setServicesTree(tree);
							setCurrentLevel(tree);
						}
						setLoading(false);
					})
					.catch(
						({
							response: {
								data: { message },
							},
						}) => {
							dialog
								.withTitle(t("Unable to load the services"))
								.withMessage(message)
								.withAction(() => props.history.goBack())
								.show();
							setLoading(false);
						}
					);
			}
		} else {
			loadBusiness();
		}
	}, []);

	// Rótulo "Com pacote" vale para todos os usuários, logados ou não
	useEffect(() => {
		if (!business?.id) return;
		packagesList(business.id, business.language)
			.then((res) => {
				const pkgs = res.data || [];
				const map = {};
				pkgs.forEach((pkg) => {
					const sid = pkg.service?.id;
					if (!sid) return;
					if (!map[sid]) map[sid] = [];
					map[sid].push(pkg);
				});
				const labelMap = {};
				Object.keys(map).forEach((sid) => {
					const label = buildPackageLabel(map[sid], sid);
					if (label) labelMap[sid] = label;
				});
				setPackageLabelMap(labelMap);
			})
			.catch(() => {
				// silently fail — package label is non-critical
			});
	}, [business?.id]);

	const loadSectors = async (categories) => {
		try {
			const sectors = await businessService.getSectors(categories.map((item) => item.id));
			localStorage.setItem("@prit-web/sectors", JSON.stringify(sectors.data));
			setLoading(false);
		} catch (err) {
			dialog
				.withMessage(t("Unable to load the sectors of this establishment"))
				.withButtonText(t("Try again"))
				.withAction(() => {
					loadSectors(categories);
				})
				.show();
			setLoading(false);
		}
	};

	const loadBusiness = () => {
		setLoading(true);
		businessService
			.getBusiness(id)
			.then((res) => {
				businessService
					.getBusinessService(id, res.data.categories[0].id, res.data.language)
					.then((res) => {
						let businessServices = res.data;
						if (businessServices) {
							setServices(businessServices);
							let tree = servicesService.buildServiceTree(businessServices, res.data.language);
							if (pet) {
								tree = servicesService.petPreselection(tree, pet);
							}
							setServicesTree(tree);
							setCurrentLevel(tree);
						}
						setLoading(false);
					})
					.catch(
						({
							response: {
								data: { message },
							},
						}) => {
							dialog
								.withTitle(t("Unable to load the services"))
								.withMessage(message)
								.withAction(() => props.history.goBack())
								.show();
							setLoading(false);
						}
					);
				dispatch(businessAction.setBusiness(res.data));
				loadSectors(res.data.categories);
			})
			.catch((err) => {
				if (err?.response?.status === 401) {
					loadBusiness();
				} else {
					dialog
						.withMessage(err?.response?.data?.message || "Ops...")
						.withButtonText(t("Try again"))
						.withAction(() => {
							loadBusiness();
						})
						.show();
				}
				setLoading(false);
			});
	};

	const openBranch = (branch) => {
		setOpenedBranchs([...openedBranchs, branch.id]);
	};

	const closeBranch = (branch) => {
		setOpenedBranchs(
			openedBranchs.filter((openedBranch) => {
				return openedBranch !== branch.id;
			})
		);
	};

	const isOpen = (branch) => {
		return openedBranchs.includes(branch.id);
	};

	const renderBranch = (branch) => {
		let selectable = branch?.branchs?.length === 0;
		let value = branch?.service;
		return (
			<>
				<div
					style={{ display: "flex", flexDirection: "column", height: "50px" }} /*key={branch.id}*/
					onClick={() => {
						if (selectable) {
							if (selectedServices.includes(branch.service)) {
								removeSelectedService(branch.service);
							} else {
								handleSelectService(branch.service);
							}
						} else {
							if (isOpen(branch)) {
								closeBranch(branch);
							} else {
								openBranch(branch);
							}
						}
					}}>
					<div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
						<div key={branch?.id} className={classes.container}>
							<span className={classes.nameList}>{branch?.name}</span>
							{value ? (
								<span className={classes.price}>
									{Utils.formatMoney((value?.price / 100), business.currency)}
								</span>
							) : (
								""
							)}
						</div>
						{selectable ? (
							<PurpleCheckBox checkedIcon={<CheckCircleIcon />} checked={selectedServices.includes(branch.service)} />
						) : isOpen(branch) ? (
							<KeyboardArrowDown />
						) : (
							<KeyboardArrowRight />
						)}
					</div>
				</div>
				{/* <Divider /> */}
				{isOpen(branch) &&
					branch.branchs.map((nextBranch, index) => {
						return (
							<div style={{ display: "flex", flexDirection: "row", flexBasis: 2, marginLeft: "10px" }}>
								<div>
									<div
										style={{
											height: "27px",
											width: "1px",
											backgroundColor: index === 0 || !isOpen(branch.branchs[index - 1]) ? "#ddd" : "transparent",
										}}
									/>

									<div
										style={{
											height: "1px",
											width: "25px",
											backgroundColor: "#ddd",
										}}
									/>
									{!(index === branch.branchs.length - 1) && !isOpen(nextBranch) && (
										<div
											style={{
												height: "23px",
												width: "1px",
												backgroundColor: "#ddd",
											}}
										/>
									)}
								</div>
								<div style={{ width: "10px" }} />

								<div style={{ flex: 1 }}>{renderBranch(nextBranch)}</div>
							</div>
						);
					})}
			</>
		);
	};

	const findServiceById = (branchs, serviceId) => {
		for (const branch of branchs) {
		  if (branch.service?.id === serviceId) {
			return branch.service.id;
		  }
		}
	};

	const renderLevel = () => {
		let orderedCurrentLevel = currentLevel.slice().filter((item) => item.name.toLowerCase().includes(search.toLowerCase()));
		orderedCurrentLevel.sort((a, b) => {
			if (a.name > b.name) {
				return 1;
			}
			if (a.name < b.name) {
				return -1;
			}
			return 0;
		});
		return orderedCurrentLevel.map((branch) => {
			let selectable = branch?.branchs?.length === 0;
			let value = branch?.service;
			let serviceIdParam;
			let isChecked;
		
			if (business.sectorId === "7a1b72d2-c6a3-4735-aec6-53848362d7c5") {
				serviceIdParam = findServiceById(branch.branchs, serviceId);
				isChecked = selectedServices.includes(branch?.service) || !!serviceIdParam;
			} else {
				serviceIdParam = branch?.service?.id === serviceId ? branch?.service : '';
				isChecked = selectedServices.includes(branch?.service) || !!serviceIdParam;
			}
			return (
				<div
					className={classes.levelTileDiv} /*key={branch.id}*/
					onClick={() => {
						if (selectable) {
							if (selectedServices.includes(branch.service)) {
								removeSelectedService(branch.service);
							} else {
								handleSelectService(branch.service);
							}
						} else {
							setCurrentLevel(branch?.branchs);
						}
					}}>
					<div className={classes.levelTileAlign} style={{ display: "flex", alignItems: "flex-start", width: "100%" }}>
						<div key={branch?.id} style={{ display: "flex", flexDirection: "column", flex: 1, minWidth: 0 }}>
							{/* Row 1: name */}
							<h4 className={classes.nameList}>{branch?.name}</h4>
							{/* Row 2: duration (left) + package label (right, under price) */}
							{value && (
								<div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginTop: 2 }}>
									<span style={{ fontSize: "clamp(12px, 2vw, 13px)", fontWeight: 400, color: "rgba(0,0,0,0.55)" }}>
										{Utils.formatMinutes(value.duration)}
									</span>
									{packageLabelMap[value.id] && (
										<span style={{ fontSize: "clamp(12px, 2vw, 13px)", fontWeight: 400, color: "#A8848C", textAlign: "right" }}>
											{packageLabelMap[value.id].multipleOffers
												? t("packageLabelFrom", { price: Utils.formatMoney(packageLabelMap[value.id].pricePerSession, business.currency) })
												: t("packageLabel", { price: Utils.formatMoney(packageLabelMap[value.id].pricePerSession, business.currency) })}
										</span>
									)}
								</div>
							)}
						</div>
						<div style={{ display: "flex", alignItems: "center", gap: "10px", flexShrink: 0, paddingLeft: 8 }}>
							{value ? (
								<h4 className={classes.price}>
									{Utils.formatMoney((value?.price / 100), business.currency)}
								</h4>
							) : ""}
							{selectable ? (
								<PurpleCheckBox checkedIcon={<CheckCircleIcon />} checked={isChecked} />
							) : (
								<KeyboardArrowRight />
							)}
						</div>
					</div>
					<Divider />
				</div>
			);
		});
	};

	const handleSchedule = () => {
		handleBreadcrumb('scheduling.service', 'Serviços selecionados, avançando para data', {
			serviceCount: selectedServices.length,
			serviceNames: selectedServices.map((s) => s.serviceName),
		});
		props.history.push(`/selecionar-data/${business.id}`, {
			services: selectedServices,
			// feature_items: feature_items,
			coupon: coupon,
		});
	};

	const footer = () => {
		return (
			<div className={classes.footerAlign} style={{ paddingTop: "20px" }}>
				<div style={{ display: "flex" }}>
					<div style={{ backgroundColor: "#450067" }} className={classes.countSelected}>
						{selectedServices.length}
					</div>
					<div className={classes.nameCountServices}>{t("Selected Services")}</div>
				</div>
				<div>
					<ColorButton
						disabled={selectedServices.length === 0}
						variant="contained"
						style={{
							backgroundColor: "#450067",
							color: "white",
							opacity: selectedServices.length === 0 ? "50%" : "100%",
						}}
						className={classes.nameButton}
						onClick={handleSchedule}>
						{t("Next")}
					</ColorButton>
				</div>
			</div>
		);
	};

	useEffect(() => {
		if (serviceId) {
		  const matchedService = currentLevel.find(branch => branch?.service?.id === serviceId)?.service;
		  if (matchedService && !selectedServices.includes(matchedService)) {
			handleSelectService(matchedService);
		  }
		}
	  }, [serviceId, currentLevel, selectedServices]);

	const handleSelectService = (item) => {
		if (!selectedServices.includes(item)) {
			setSelectedServices([...selectedServices, item]);
		}
	};

	const removeSelectedService = (item) => {
		setSelectedServices(selectedServices.filter((element) => element.id !== item.id));
	};

	return (
		<Fragment>
			<SpinnerLoading loading={loading} />
			<TitleContainer
				footer={footer()}>
				<div className={classes.centerDiv} style={{position: "relative", top:"0", left:"0", marginBottom: "10px"}}>
						<ArrowBackIos
							onClick={() => {
								if (business.categories.length > 1) {
									props.history.goBack();
								} else {
									props.history.push(`/business/${business.id}`);
								}
							}}
						/>
						{/* <Typography className={classes.selectServicesLabel}>{t("Select Service")}</Typography> */}
					</div>
				<CustomCardHeader business={business} />
				<div style={{ marginBottom: "5%", padding: "16px", paddingBottom: "0" }}>
					{business?.address && (
						<>
							<Typography className={classes.descriptionTextAddress}>
								{`${Utils.capitalize(business.address.street)}, ${business.address.number} - ${Utils.capitalize(
									business.address.neighborhood
								)},  ${Utils.capitalize(business.address.city)} - ${
									business.address.state
								} - CEP ${business.address.postalCode}`}
							</Typography>
						</>
					)}
				</div>
				<Divider />
				<div
					style={{
						display: "flex",
						overflowX: selectedServices?.length > 0 ? "scroll" : "none",
						overflowY: "hidden",
						marginTop: "15px",
					}}>
					<FeaturesSelected features={selectedServices} handleDelete={removeSelectedService} />
				</div>
				<div style={{ height: "10px" }}></div>
				<Paper component="form" className={classes.root} style={{ marginBottom: "15px", background: "#D9D9D9", borderRadius:"46px", height:"45px" }}>
					<IconButton className={classes.iconButton} aria-label="search" disabled={true}>
						<SearchIcon />
					</IconButton>
					<InputBase
						style={{ fontSize: "14px" }}
						value={search}
						onChange={(e) => {
							setSearch(e.target.value);
						}}
						className={classes.inputSearch}
						placeholder={t("Name Service")}
						inputProps={{ "aria-label": "search service" }}
					/>
				</Paper>
				<div>
					<Typography className={classes.levelTitle}>{t("Selecionar Serviço")}</Typography>
					{
						// search.length > 0
						// 	? servicesTree
						// 			.sort((a, b) => a.name.localeCompare(b.name))
						// 			.filter((item) => item.name.toLowerCase().includes(search.toLowerCase()))
						// 			.map((item) => <div key={item.id}>{renderBranch(item)}</div>)
						// 	:
						services?.length > 0
							? treeView
								? servicesTree.map((item) => <div key={item.id}>{renderBranch(item)}</div>)
								: renderLevel()
							: !loading && <div className={classes.noServicesAvailble}>{t("No services available")}</div>
					}
				</div>
			</TitleContainer>
		</Fragment>
	);
};
export default withRouter(ServiceScheduling);
